import { companyModel } from "../../models/hubspotModel";
import { ReadOnlyProps } from "../../utils/templates";

interface props {
  companiesList: Array<companyModel>;
  isCompaniesListLoaded: boolean;
  selectedContainer: companyModel;
  isCompaniesTableRefreshed: boolean;
}

export const hubspotState: ReadOnlyProps<props> = {
  companiesList: [],
  isCompaniesListLoaded: false,
  selectedContainer: {} as unknown as companyModel,
  isCompaniesTableRefreshed: false,
};
